import { render, staticRenderFns } from "./IcoBriefcaseClock.vue?vue&type=template&id=f8096bc8"
import script from "./IcoBriefcaseClock.vue?vue&type=script&lang=js"
export * from "./IcoBriefcaseClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports